import { render } from "./LorealProject.vue?vue&type=template&id=4dda8809"
import script from "./LorealProject.vue?vue&type=script&lang=js"
export * from "./LorealProject.vue?vue&type=script&lang=js"

import "./LorealProject.vue?vue&type=style&index=0&id=4dda8809&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__